import { render, staticRenderFns } from "./Posts2.vue?vue&type=template&id=0d4248e6&scoped=true&"
import script from "./Posts2.vue?vue&type=script&lang=js&"
export * from "./Posts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4248e6",
  null
  
)

export default component.exports